import React from "react"
import {NewsLayout} from "sections/News/"
import useNewsData from "shared/Hooks/News/useNewsData"
import {TextBlock} from "src/sections/News/NewsLayout/TextBlock";
import {NEWS_17} from "types/News"
import {Images} from '../../sections/News/NewsLayout/Images';

const Article = () => {
  const data = useNewsData(NEWS_17);

  return (
    <NewsLayout data={data}>
      <TextBlock data={data.texts.first}/>
      <Images data={data.images.first}/>
    </NewsLayout>
  )
}

export default Article
